// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__gRFIB","disabled":"FileBtn_disabled__2FDDk","warn":"FileBtn_warn__3UqxD","fade":"FileBtn_fade__3EUL9"};